import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-core',
  templateUrl: './main-core.component.html',
  styleUrls: ['./main-core.component.scss']
})
export class MainCoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
